module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "data-driven-testing.2b1a8bb7.svg";